import { ADD_SCHEDULED_VISIT_ID, SCHEDULED_VISITS_FAIL, SCHEDULED_VISITS_REQUEST, SCHEDULED_VISITS_SUCCESS } from '../types/actionTypes';

export const scheduledVisitsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case ADD_SCHEDULED_VISIT_ID:      
      return { ...state,  scheduledVisitId: action.payload  }
    case SCHEDULED_VISITS_REQUEST:
      return { ...state, loading: true };
    case SCHEDULED_VISITS_SUCCESS:
      return { loading: false, scheduledVisits: action.payload };
    case SCHEDULED_VISITS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
